export default {
  setVeiculos(state, payload) {
    state.veiculos = payload
  }
}
